import { Storage } from "@/services/interfaces/enums";

export const getUser = (key: string = Storage.USER) => {
  const user = localStorage.getItem(key);
  return user ? JSON.parse(user) : null;
};
